import { render, staticRenderFns } from "./downloadCertificate.vue?vue&type=template&id=6bfaeaa1"
import script from "./downloadCertificate.vue?vue&type=script&lang=js"
export * from "./downloadCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports